import { render, staticRenderFns } from "./Pillar1.vue?vue&type=template&id=b285fc8a&"
import script from "./Pillar1.vue?vue&type=script&lang=js&"
export * from "./Pillar1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports